function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVoteBoxNoDrop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 805 471",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-696.812,-756.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M696.812,1226.65C696.812,1226.65 696.822,1064.36 696.825,1010.05C696.825,998.568 699.577,987.258 704.85,977.064C730.128,928.19 806.443,780.642 806.443,780.642C814.161,765.668 829.597,756.259 846.443,756.259L1361.87,756.259C1379.35,756.259 1395.25,766.381 1402.65,782.219C1402.65,782.219 1472.02,930.786 1494.18,978.231C1498.6,987.703 1500.9,998.027 1500.92,1008.48C1501.02,1061.12 1501.32,1226.65 1501.32,1226.65L696.812,1226.65Z",
    style: {
      fill: "rgb(224,213,207)"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVoteBoxNoDrop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vote-box-no-drop.fffd5119959726fbe906998655804885.svg";